import {ILabelFormatData} from "../interfaces/ILabelFormatData";
import {LabelType} from "./enums/LabelType";
import {AnnotationFormatType} from "./enums/AnnotationFormatType";

export type ExportFormatDataMap = { [s in LabelType]: ILabelFormatData[]; };

export const EnExportFormatData: ExportFormatDataMap = {
    "RECT": [
        {
            type: AnnotationFormatType.YOLO,
            label: "A .zip package containing files in YOLO format. (AI Module)"
        },
        {
            type: AnnotationFormatType.VOC,
            label: "A .zip package containing files in VOC XML format. (CocoPi)"
        },
        // {
        //     type: AnnotationFormatType.CSV,
        //     label: "Single CSV file."
        // }
    ],
    "POINT": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "LINE": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "POLYGON": [
        {
            type: AnnotationFormatType.VGG,
            label: "Single file in VGG JSON format."
        },
        {
            type: AnnotationFormatType.COCO,
            label: "Single file in COCO JSON format."
        }
    ],
    "IMAGE RECOGNITION": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        },
        {
            type: AnnotationFormatType.JSON,
            label: "Single JSON file."
        }
    ]
}

export const zh_HansEnExportFormatData: ExportFormatDataMap = {
    "RECT": [
        {
            type: AnnotationFormatType.YOLO,
            label: "包含YOLO格式文件的.zip软件包。(AI模块)"
        },
        {
            type: AnnotationFormatType.VOC,
            label: "包含VOC XML格式文件的.zip软件包。(CocoPi)"
        },
        // {
        //     type: AnnotationFormatType.CSV,
        //     label: "Single CSV file."
        // }
    ],
    "POINT": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "LINE": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "POLYGON": [
        {
            type: AnnotationFormatType.VGG,
            label: "Single file in VGG JSON format."
        },
        {
            type: AnnotationFormatType.COCO,
            label: "Single file in COCO JSON format."
        }
    ],
    "IMAGE RECOGNITION": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        },
        {
            type: AnnotationFormatType.JSON,
            label: "Single JSON file."
        }
    ]
}

export const zh_HantEnExportFormatData: ExportFormatDataMap = {
    "RECT": [
        {
            type: AnnotationFormatType.YOLO,
            label: "包含YOLO格式文件的.zip軟件包。(AI模組)"
        },
        {
            type: AnnotationFormatType.VOC,
            label: "包含VOC XML格式文件的.zip軟件包。(CocoPi)"
        },
        // {
        //     type: AnnotationFormatType.CSV,
        //     label: "Single CSV file."
        // }
    ],
    "POINT": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "LINE": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        }
    ],
    "POLYGON": [
        {
            type: AnnotationFormatType.VGG,
            label: "Single file in VGG JSON format."
        },
        {
            type: AnnotationFormatType.COCO,
            label: "Single file in COCO JSON format."
        }
    ],
    "IMAGE RECOGNITION": [
        {
            type: AnnotationFormatType.CSV,
            label: "Single CSV file."
        },
        {
            type: AnnotationFormatType.JSON,
            label: "Single JSON file."
        }
    ]
}